/* eslint-disable */

import request from '@/utils/request'

export function getListWarehouseApi(query) {
  return request({
    url: '/config-service/v1/warehouse/warehouse',
    method: 'get',
    params: query
  })
}

export function addWarehouseApi(query) {
  return request({
    url: '/config-service/v1/warehouse/warehouse',
    method: 'post',
    data: query
  })
}

export function updateWarehouseApi(query) {
  return request({
    url: `/config-service/v1/warehouse/warehouse/${query.id}`,
    method: 'put',
    data: query
  })
}

export function deleteWarehouseApi(query) {
  return request({
    url: '/config-service/v1/warehouse/warehouse',
    method: 'delete',
    data: query
  })
}
